export default "__VITE_ASSET__650cfGHz__"